<template>
  <register-container>
    <template slot="header" v-if="showTitle">{{
      pageTitle || $t('registration.registerSurvey.title')
    }}</template>
    <template slot="subtitle" v-if="showSubtitle">{{ pageSubtitle }} </template>
    <div
      class="content-wrap d-flex justify-center"
      :class="{
        'align-center': $vuetify.breakpoint.smAndDown,
        'align-start': $vuetify.breakpoint.mdAndUp,
        'mt-10': showTitle || showSubtitle,
      }"
      :style="{ minHeight }"
    >
      <survey-form
        v-if="!surveyCompleted && schema"
        :schema="schema"
        :templateId="formId"
        @newSubmission="onSubmit"
        :onSurveyCreate="onSurveyCreate"
        :customSubmit="customSubmit"
      ></survey-form>
      <div v-else-if="surveyCompleted && !noTemplate" class="d-flex flex-column justify-center">
        <v-icon color="success" :size="$vuetify.breakpoint.mdAndUp ? '100' : '50'"
          >mdi-checkbox-marked-circle</v-icon
        >
        <div
          class="mt-2"
          :style="{
            fontSize: $vuetify.breakpoint.mdAndUp ? '1.4rem' : '1.2rem',
          }"
        >
          {{ $t('registration.registerSurvey.complete') }}
        </div>
        <div class="pa-4">
          <v-btn text color="primary" @click="goBackInSurvey">Back</v-btn>
        </div>
      </div>
      <div v-else-if="surveyCompleted && noTemplate" class="d-flex flex-column justify-center">
        <v-icon :size="$vuetify.breakpoint.mdAndUp ? '100' : '50'"
          >mdi-checkbox-marked-circle</v-icon
        >
        <div
          class="mt-2"
          :style="{
            fontSize: $vuetify.breakpoint.mdAndUp ? '1.4rem' : '1.2rem',
          }"
        >
          {{ $t('registration.registerSurvey.noData') }}
        </div>
      </div>
      <div v-else>
        <v-progress-circular
          indeterminate
          width="10"
          :size="$vuetify.breakpoint.mdAndUp ? '80' : '50'"
          color="success"
        ></v-progress-circular>
      </div>
    </div>
  </register-container>
</template>
<style scoped>
.content-wrap {
  min-height: 600px;
}
</style>
<script>
import to from 'await-to-js';
import RegisterContainer from '../components/RegisterContainer.vue';
import SurveyForm from '../components/SurveyForm.vue';
import f from '../utils/fetch';

export default {
  name: 'RegisterSurvey',
  data() {
    return {
      showFooter: true,
      customSubmit: null,
      formId: null,
      noTemplate: false,
      surveyCompleted: false,
      template: null,
      schema: null,
      model: null,
      templateId: null,
      showEndSplash: true,
      survey: null,
    };
  },
  components: { RegisterContainer, SurveyForm },
  computed: {
    completed() {
      return this.surveyCompleted;
    },
    form() {
      return this.$route.query.form || this.$store.state.registration.form;
    },
    minHeight() {
      return this.$vuetify.breakpoint.smAndDown ? `300px` : '600px';
    },
    tenantUrl() {
      return this.$store.state.registration.tenantUrl;
    },
  },
  methods: {
    goBackInSurvey() {
      this.surveyCompleted = false;
    },
    getSurvey() {
      this.templateId = this.form;
    },
    onSubmit() {
      this.surveyCompleted = true;

      if (this.showEndSplash) {
        this.$emit('changeOptions', { showFooter: true });
      } else {
        this.$emit('next', { clearHistoryItem: this.$options.name });
      }
    },
    async loadTemplates(templateId) {
      if (!templateId) {
        this.noTemplate = true;
        this.onSubmit();
        return;
      }
      const providerId = this.$store.getters.getProviderId();
      this.loading = true;

      const [error, template] = await to(
        f(`providers/${providerId}/publicTemplates/${templateId}`)
      );

      if (!error) {
        this.template = template;
        this.schema = template.schema;
        this.formId = template.id;
      }

      if (!this.schema) {
        this.noTemplate = true;
        this.onSubmit();
      }

      this.loading = false;
    },
    setSurvey(val) {
      this.survey = val;
    },
  },
  async mounted() {
    this.getSurvey();
    this.$store.commit('setCompleted', this.completed);
    this.$store.commit('setOnNextClick', () => {
      this.$store.commit('setCompleted', false);
      if (!this.isPageflowV2) {
        this.$router.push({
          name: this.$store.getters.nextFlowRoute(this.$route.name),
        });
      } else {
        this.$emit('next');
      }
    });
    this.initVariables = { survey: this.survey };
    this.$nextTick(() => {
      this.loadTemplates(this.form);
    });
  },
  watch: {
    completed(val) {
      this.$store.commit('setCompleted', val);
    },
  },
};
</script>
